import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
  MatTabChangeEvent,
  MatTabGroup,
} from '@angular/material/tabs';
import {
  ImageUpload,
  ManagementService,
  ReportsService,
} from 'src/app/api/generated';
import { DataChangedService } from 'src/app/data-changed.service';
import { ReportModulesService } from 'src/app/services/report-modules/report-modules.service';
import { WebcamConfig } from '../../webcam.tools';

import * as uuid from 'uuid';
import { DefaultService } from 'src/app/api/webcam';

interface WebcamLocationOption {
  id: string | number;
  name: string;
  auftraggeber?: string;
}

@Component({
    selector: 'app-webcam-viewer-config',
    templateUrl: './webcam-config.component.html',
    styleUrls: ['./webcam-config.component.scss'],
    standalone: false
})
export class WebcamConfigComponent implements OnInit, AfterViewInit {
  public webcamForm: UntypedFormGroup;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @ViewChild('image', { static: false }) image: ElementRef;

  public editMode = false;
  public availableLocations: WebcamLocationOption[] = [];
  public submitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WebcamConfig,
    private dialogRef: MatDialogRef<WebcamConfig>,
    private formBuilder: UntypedFormBuilder,
    private reportModuleService: ReportModulesService,
    private dataChangedService: DataChangedService,
    private reportService: ReportsService,
    private cdr: ChangeDetectorRef,
    private webcamService: DefaultService
  ) {}

  ngOnInit(): void {
    this.editMode = this.data?.guid !== undefined;
    this.webcamForm = this.formBuilder.group({
      guid: [this.data?.guid ? this.data.guid : uuid.v4()],
      headline: [this.data?.headline ? this.data.headline : ''],
      imageCaption: [this.data?.description ? this.data.description : ''],
      type: ['webcam'],
      location: [this.data?.location ? this.data.location : 1],
    });

    this.webcamService
      .getLocationsApiLocationsGet()
      .subscribe((locations: WebcamLocationOption[]) => {
        for (const location of locations) {
          this.availableLocations.push(location);
        }
      });
  }

  get locations(): UntypedFormArray {
    return this.webcamForm.get('locations') as UntypedFormArray;
  }

  async ngAfterViewInit() {}

  public async updateOrCreateModule() {
    if (this.webcamForm.valid) {
      this.submitting = true;
      this.reportModuleService
        .addOrEditModuleToReport(
          <WebcamConfig>{
            guid: this.webcamForm.value.guid,
            type: this.webcamForm.value.type,
            description: this.webcamForm.value.imageCaption,
            headline: this.webcamForm.value.headline,
            location: this.webcamForm.value.location,
          },
          this.editMode
        )
        .subscribe(
          (success) => {
            this.submitting = false;
            this.dialogRef.close();
            this.dataChangedService.configUpdated(
              this.reportModuleService.currentReport.id,
              this.webcamForm.value.guid
            );
          },
          (error) => {
            this.submitting = false;
            console.error(error);
          }
        );
    }
  }
}
